<template lang="pug">
tl-position(
    :style="{ width: 1.5 * size + 'px', height: 1.5 * size + 'px' }"
    class="tl-loading-circle"
    x="center"
    y="center"
)
    div(
        :style="{ width: size + 'px', height: size + 'px' }"
        class="sk-chase"
    )
        div(class="sk-chase-dot")
            div(
                :style="dotStyle"
            )
        div(class="sk-chase-dot")
            div(
                :style="dotStyle"
            )
        div(class="sk-chase-dot")
            div(
                :style="dotStyle"
            )
        div(class="sk-chase-dot")
            div(
                :style="dotStyle"
            )
        div(class="sk-chase-dot")
            div(
                :style="dotStyle"
            )
        div(class="sk-chase-dot")
            div(
                :style="dotStyle"
            )
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    color: String,
    size: [String, Number],
})

const injects = getInjects(props, inject)

const size = computed(() => parseInt(props.size, 10) ?? parseInt(injects.size?.value, 10) ?? 40)
const color = computed(() => props.color ?? injects.color?.value ?? 'white')

const dotStyle = computed(() => ({
    backgroundColor: `var(--color-${color.value})`,
}))

</script>

<style lang="sass" scoped>
.tl-loading-circle
    .sk-chase
        position: relative
        animation: sk-chase 2.5s infinite linear both

    .sk-chase-dot
        width: 100%
        height: 100%
        position: absolute
        left: 0
        top: 0
        animation: sk-chase-dot 2.0s infinite ease-in-out both

    .sk-chase-dot > div
        display: block
        width: 20%
        height: 20%
        border-radius: 100%
        animation: sk-chase-dot-before 2.0s infinite ease-in-out both

    .sk-chase-dot:nth-child(1)
        animation-delay: -1.1s
    .sk-chase-dot:nth-child(2)
        animation-delay: -1.0s
    .sk-chase-dot:nth-child(3)
        animation-delay: -0.9s
    .sk-chase-dot:nth-child(4)
        animation-delay: -0.8s
    .sk-chase-dot:nth-child(5)
        animation-delay: -0.7s
    .sk-chase-dot:nth-child(6)
        animation-delay: -0.6s
    .sk-chase-dot:nth-child(1):before
        animation-delay: -1.1s
    .sk-chase-dot:nth-child(2):before
        animation-delay: -1.0s
    .sk-chase-dot:nth-child(3):before
        animation-delay: -0.9s
    .sk-chase-dot:nth-child(4):before
        animation-delay: -0.8s
    .sk-chase-dot:nth-child(5):before
        animation-delay: -0.7s
    .sk-chase-dot:nth-child(6):before
        animation-delay: -0.6s

    @keyframes sk-chase
        100%
            transform: rotate(360deg)

    @keyframes sk-chase-dot
        80%,
        100%
            transform: rotate(360deg)

    @keyframes sk-chase-dot-before
        50%
            transform: scale(0.4)

        100%,
        0%
            transform: scale(1)
</style>
